<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-header>
                <i class="icon-menu mr-1"></i>Системные логи
                <i class="badge badge-success">Новое</i>
                <div class="card-header-actions" v-if="is_god">
                    <a href="https://github.com/matfish2/vue-tables-2" rel="noopener noreferrer" target="_blank" className="card-header-action"><small className="text-muted">docs</small></a>
                </div>
            </b-card-header>
            <b-card-body>
                <div id="events">
                    <v-server-table :url="apiurl('log/table')"  :columns="columns" :options="options" :theme="theme" id="logsTable"  ref="logsTable">

                        <div slot="child_row" slot-scope="props">
                            Дата события: {{props.row.date_create_iso}}<br>
                            ID пользователя: {{props.row.user_creator_id}}<br>
                            Уровень: {{props.row.level_interest}}<br>
                            Kомментарий: {{props.row.comment_text}}<br>
                        </div>

                        <span slot="user_creator_id" slot-scope="props">
                            <template v-if="is(props.row.user)">
                                {{props.row.user.login}} (#{{props.row.user_creator_id}})
                            </template>

                        </span>

                    </v-server-table>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

    import Vue from 'vue'
    import { ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import date_create_iso from '../jsx/logs/date_create_iso'
    import comment_text from '../jsx/logs/comment_text'
    import {CONSTANTS} from '@/constants';

    Vue.use(ServerTable)

    export default {
        name: 'NsbAdminLogs',
        components: { ServerTable, Event,  },
        mixins: [functions],
        data: function () {
            return {
                columns: ['id', 'date_create_iso', 'user_creator_id', 'level_interest', 'comment_text', 'table_register', 'doc_id', ],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        date_create_iso: 'дата/время',
                        user_creator_id: 'владелец',
                        level_interest: 'уровень лога',
                        comment_text: 'комментарий',
                        table_register: 'класс',
                        doc_id: 'объект',
                    },
                    dateColumns:['date_create_iso'],
                    columnsDisplay: {
                        id: 'min_tabletL',
                        date_create_iso: 'min_mobile',
                        level_interest: 'min_tabletL',
                        comment_text: 'min_mobile',
                        table_register: 'min_tabletL',
                        doc_id: 'min_tabletL',
                    },
                    sortable: ['date_create_iso'],
                    filterable: ['id', 'date_create_iso', 'user_creator_id', 'level_interest', 'comment_text', 'table_register', 'doc_id'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    templates: {
                        date_create_iso,
                            comment_text
                    },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                },
                theme: 'bootstrap4',
                template: 'default'
            }
        },
        methods: {
        },
        created: function() {
        },
        mounted: function () {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        },

    };
</script>

<style lang="scss">

</style>
